import "./style.css";

export default class UserMenu {
  static selector = ".s-user-menu";

  constructor(block) {
    this.block = block;
    this.$popup = document.body.querySelector("#s-popup-logout");
  }

  onSignOut(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this.$popup.setAttribute("data-active", 1);
  }

  onCancel(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    this.$popup.setAttribute("data-active", 0);
  }

  onReady() {
    const logoutHref = this.block
      .querySelector("#logout a")
      .getAttribute("href");

    const $signout = this.block.querySelector("a#sign-out");
    $signout.addEventListener("click", this.onSignOut.bind(this));

    const $popupSignoutButton = document.querySelector(".s-signout a");
    $popupSignoutButton.setAttribute("href", logoutHref);
    $popupSignoutButton.setAttribute("target", "_self");

    const $popupCancelButton = document.querySelector(".s-cancel a");
    $popupCancelButton.addEventListener("click", this.onCancel.bind(this));
  }
}
